<template>
    <div class="question-card">
        <div class="header">
            <div class="title">答题卡</div>
            <div class="question-status">
                <span class="finish">已答</span>
                <!-- <span class="incomplete">未完成</span> -->
                <span class="unfinish">未答</span>
            </div>
        </div>

        <div class="module-list">
            <div class="module-item" v-for="mItem in moduleList" :key="mItem.id">
                <div class="module-unit" v-if="unitMap[mItem.id]">
                    {{ unitMap[mItem.id] }}
                </div>
                <div class="module-title" :title="mItem.title">{{ mItem.title }}</div>
                <div class="module-container">
                    <template v-for="item in mItem.questions">
                        <div v-if="item.indexNo" :key="item.id" class="question-index">
                            <span @click="onChangeQuestion(item)" :class="questionClassMap[`q-${item.id}`]">
                                {{ item.indexNo }}
                            </span>
                        </div>
                        <template v-else-if="item.childQuestions">
                            <div v-for="childItem in item.childQuestions" :key="childItem.id" class="question-index">
                                <span
                                    @click="onChangeQuestion(item, childItem)"
                                    :class="questionClassMap[`q-${childItem.id}`]"
                                >
                                    {{ childItem.indexNo }}
                                </span>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>
        <van-button @click="onSubmit" class="submit-btn" block round color="#ff8c00">立即提交</van-button>
    </div>
</template>
<script>
import { commitPaperStashAnswer } from '@/api/paperApi.js'

export default {
    computed: {
        batchNo() {
            return this.$store.state.paperDetails.batchNo
        },
        paperInfo() {
            return this.$store.state.paperDetails.paperInfo
        },
        userAnswerMap() {
            return this.$store.state.paperDetails.userAnswerMap
        },
        moduleList() {
            return this.$store.state.paperDetails.moduleList
        },
        answerTime() {
            return this.$store.state.paperDetails.answerTime
        },
        questionClassMap() {
            const map = {}
            Object.keys(this.userAnswerMap || {}).forEach((key) => {
                map[key] = ''
                if (this.userAnswerMap[key]) {
                    map[key] = 'state-1'
                    if (this.userAnswerMap[key]['state']) map[key] = 'state-2'
                }
            })
            return map
        },
        unitMap() {
            const map = {}
            const _list = []
            this.moduleList.forEach((item) => {
                if (!_list.includes(item.unit)) {
                    map[item.id] = item.unit
                    _list.push(item.unit)
                }
            })
            return map
        },
    },

    methods: {
        onChangeQuestion(item, child) {
            this.$store.dispatch('paperDetails/setJumpQuestion', {
                questionId: item.id,
                subQuestionId: child ? child.id : null,
            })
            this.$store.dispatch('paperDetails/setQuestionCardState', false)
        },
        onSubmit() {
            // 检测当前是否有未完成试题
            // 0: 未做题  1: 完成部分 2: 全部完成
            let state = 2
            const list = []
            Object.keys(this.userAnswerMap).forEach((key) => {
                if (!this.userAnswerMap[key]) state = 1
                if (this.userAnswerMap[key] && !this.userAnswerMap[key]['state']) state = 1
                if (this.userAnswerMap[key]) {
                    list.push({
                        questionId: key.split('-')[1],
                        answer: this.userAnswerMap[key]['answer'].join('@@'),
                    })
                }
            })
            if (list.length === 0) state = 0

            if (state === 0) {
                return this.$toast('请先作答试卷，再提交')
            } else if (state === 1) {
                this.$dialog
                    .confirm({ message: '试卷中还有未作答的试题，是否继续提交试卷？' })
                    .then(() => {
                        this.commitAnswerApi()
                    })
                    .catch(() => {})
            } else {
                this.commitAnswerApi()
            }
        },
        commitAnswerApi() {
            console.log(this.batchNo)
            commitPaperStashAnswer({ batchNo: this.batchNo }).then(() => {
                this.$toast.success('提交成功')
                this.$router.push(`/paperResult/${this.paperInfo.paperNo}/${this.batchNo}`)
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.question-card {
    height: 100%;
}
.header {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #efefef;
    .title {
        font-size: 16px;
        font-weight: 700;
    }
    .question-status {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #99948d;
        margin-right: 40px;
        span {
            display: flex;
            align-items: center;
        }
        .incomplete,
        .finish {
            margin-right: 12px;
        }
        .incomplete::after,
        .unfinish::after,
        .finish::after {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background: #ff8c00;
            border: 1px solid #ff8c00;
            margin-left: 4px;
            border-radius: 10px;
        }
        .unfinish::after {
            background: none;
        }
        .incomplete::after {
            background: rgba($color: #ff8c00, $alpha: 0.2);
        }
    }
}

.module-list {
    height: calc(100% - 110px);
    overflow-y: auto;
    .module-unit {
        margin: 8px 0 12px;
        padding: 12px 24px;
        font-weight: 600;
        font-size: 15px;
        border-bottom: 1px solid #efefef;
    }
    .module-item {
        margin: 8px 0 12px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .module-title {
        margin: 0 24px;
        font-size: 14px;
        color: #999;
        line-height: 1.6em;
        user-select: none;
    }
    .module-container {
        padding: 12px 24px 0 24px;
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        .question-index {
            display: flex;
            justify-content: center;
            span {
                user-select: none;
                width: 36px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #ff8c00;
                box-sizing: border-box;
                border-radius: 40px;
                color: #666666;
                font-size: 14px;
            }
            .state-1 {
                background: rgba($color: #ff8c00, $alpha: 0.2);
            }
            .state-2 {
                color: #ffffff;
                background: #ff8c00;
            }
        }
    }
}
.submit-btn {
    width: 80%;
    max-width: 280px;
    height: 32px;
    margin: 4px auto;
}
</style>
